import React, { Component } from 'react';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import { Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Select from '@mui/material/Select';
import Autocomplete from '@mui/material/Autocomplete';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import Stack from '@mui/material/Stack';
import { LineChart } from '@mui/x-charts/LineChart';
import { CircularProgress } from '@mui/material';

const componentStyles = {
    rootPaper: {
        flex: '1 1 30%',
        margin: '8px',
        minWidth: 300,
        display: 'flex',
        flexDirection: 'column',
        '& h3': {
            padding: '10px 2%',
        },
    },
    tableContainer: {
        maxHeight: 300,
        overflowY: 'auto',
    },
    table: {
        minWidth: 400,
    },
    moreLink: {
        textAlign: 'center',
        padding: '8px',
        cursor: 'pointer',
        color: '#1976d2',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    tablesContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        padding: '16px',
    },
    chartContainer: {
        flex: '1 1 30%',
        margin: '8px',
        minWidth: 300,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
		
    },
    chartTitle: {
        padding: '10px 2%',
        marginBottom: '10px',
    },
    chartContentWrapper: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    chartTitleRight: {
        padding: '10px 2%',
        flexGrow: 1,
        textAlign: 'right',
        marginBottom: '10px',
    },
    legendStyle: {
        right: 0,
        lineHeight: '24px',
    },
    lineChartPaper: {
        flex: '1 1 100%',
        margin: '8px',
        minWidth: 300,
        display: 'flex',
        flexDirection: 'column',
        height: 450,
    }
};

class DashboardTable extends Component {
    constructor(props) {
        super(props);
        this.navigate = this.props.navigate;
    }

    render() {
        const { data, columns, emptyMessage, moreLinkPath } = this.props;
        const displayedRows = Array.isArray(data) ? data.slice(0, 5) : [];

        const tableColumns = [{
            key: 'serial_number',
            render: (_, index) => `${index + 1}.`,
            width: '2px',
            sortable: false
        }, ...columns];

        return (
            <>
                <TableContainer style={componentStyles.tableContainer}>
                    <Table stickyHeader aria-label="dashboard table" style={componentStyles.table}>
                        <TableBody>
                            {displayedRows.length > 0 ? (
                                displayedRows.map((item, index) => (
                                    <TableRow key={index}>
                                        {tableColumns.map((col) => (
                                            <TableCell
                                                key={col.key}
                                                style={{
                                                    textAlign: col.key === 'vbp_total' ? 'right' : 'left',
                                                    padding: '4px 8px',
                                                    whiteSpace: 'nowrap',
                                                    ...(col.width ? { width: col.width } : {})
                                                }}
                                            >
                                                {col.render ? col.render(item, index) : item[col.key]}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={tableColumns.length} align="center">
                                        {emptyMessage}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {Array.isArray(data) && data.length > 5 && (
                    <div
                        style={componentStyles.moreLink}
                        onClick={() => this.navigate(moreLinkPath)}
                    >
                        Show More
                    </div>
                )}
            </>
        );
    }
}

class OverdueSalesInvoiceTable extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            { key: 'vb_billdate', render: (item) => item.vb_billdate || 'N/A' },
            { key: 've_businessname', render: (item) => item.ve_businessname || 'N/A' },
            {
                key: 'vbp_total',
                render: (item) => `$${parseFloat(item.vbp_total || 0).toFixed(2)}`
            },
        ];
    }

    render() {
        const { salesinvoice } = this.props;
        return (
            <Paper style={componentStyles.rootPaper} className="dashboardpad">
                <h3>Overdue Vendor Bills</h3>
                <DashboardTable
                    data={salesinvoice}
                    columns={this.columns}
                    emptyMessage="No overdue vendor bills found."
                    moreLinkPath="/Adminvendorbills?status=7"
                />
            </Paper>
        );
    }
}

class TopCustomersPaidTable extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            { key: 've_businessname', render: (item) => item.ve_businessname || 'N/A' },
            {
                key: 'vbp_total',
                render: (item) => `$${parseFloat(item.vbp_total || 0).toFixed(2)}`
            },
        ];
    }

    render() {
        const { topCustomersPaid } = this.props;
        return (
            <Paper style={componentStyles.rootPaper} className="dashboardpad">
                <h3>Top 5 Vendors</h3>
                <DashboardTable
                    data={topCustomersPaid}
                    columns={this.columns}
                    emptyMessage="No top Vendors found."
                    moreLinkPath="/Adminsalesinvoice"
                />
            </Paper>
        );
    }
}

class TopAROutstandingTable extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            { key: 've_businessname', render: (item) => item.ve_businessname || 'N/A' },
            {
                key: 'vbp_total',
                render: (item) => `$${parseFloat(item.vbp_total || 0).toFixed(2)}`
            },
        ];
    }

    render() {
        const { topAROutstanding } = this.props;
        return (
            <Paper style={componentStyles.rootPaper} className="dashboardpad">
                <h3>Top A/P Outstanding</h3>
                <DashboardTable
                    data={topAROutstanding}
                    columns={this.columns}
                    emptyMessage="No top A/R outstanding found."
                    moreLinkPath="/Accountspayablereport"
                />
            </Paper>
        );
    }
}

class DueOverdueCharts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalDueAmount: 0,
            totalOverdueAmount: 0
        };
    }

    componentDidMount() {
        this.calculateAmounts(this.props.salesinvoiceOverdue);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.salesinvoiceOverdue !== this.props.salesinvoiceOverdue) {
            this.calculateAmounts(this.props.salesinvoiceOverdue);
        }
    }

    calculateAmounts = (salesinvoiceOverdue) => {
        const totalDueAmount = Array.isArray(salesinvoiceOverdue)
            ? salesinvoiceOverdue.reduce((sum, invoice) => sum + parseFloat(invoice.due_amount || 0), 0)
            : 0;
        const totalOverdueAmount = Array.isArray(salesinvoiceOverdue)
            ? salesinvoiceOverdue.reduce((sum, invoice) => sum + parseFloat(invoice.overdue_amount || 0), 0)
            : 0;
        this.setState({ totalDueAmount, totalOverdueAmount });
    };

    render() {
        const { totalDueAmount, totalOverdueAmount } = this.state;
        const totalOverallAmount = totalDueAmount + totalOverdueAmount;
        const COLORS = ['orange', 'red'];

        const data = [
            { name: 'Due Amount', value: totalDueAmount },
            { name: 'Overdue Amount', value: totalOverdueAmount }
        ].filter(item => item.value > 0); 

        return (
            <Paper style={componentStyles.chartContainer} className="dashboardpad">
                <h3>Outstanding Vendor Bills</h3>
                <div style={componentStyles.chartContentWrapper}>
                    {data.length > 0 ? (
                        <ResponsiveContainer height={200}>
                            <PieChart>
                                <Pie
                                    data={data}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={40}
                                    outerRadius={60}
                                    fill="#8884d8"
                                    paddingAngle={5}
                                    dataKey="value"
                                >
                                    {data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip formatter={(value) => `$${value.toFixed(2)}`} />
                                <Legend
                                    layout="vertical"
                                    verticalAlign="middle"
                                    align="right"
                                    wrapperStyle={componentStyles.legendStyle}
                                    formatter={(value, entry) => {
                                        const amount = entry.payload.value;
                                        const percentage = totalOverallAmount > 0
                                            ? ((amount / totalOverallAmount) * 100).toFixed(1)
                                            : 0;
                                        const title = entry.payload.name;
                                        return (
                                            <span style={{ color: 'black', fontWeight: 'bold' }}>
                                                {title}
                                                <div style={{
                                                    borderBottom: '1px solid black',
                                                    width: '100%',
                                                    marginTop: '2px',
                                                    marginBottom: '2px'
                                                }}></div>
                                                <span>
                                                    ${amount.toFixed(2)} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{percentage}%
                                                </span>
                                            </span>
                                        );
                                    }}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    ) : (
                        <p>No outstanding vendor bills data available.</p>
                    )}
                </div>
            </Paper>
        );
    }
}


class VendorBillLedgerChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: []
    };
  }

  componentDidMount() {
    this.prepareChartData(this.props.ledgerAmounts);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ledgerAmounts !== this.props.ledgerAmounts) {
      this.prepareChartData(this.props.ledgerAmounts);
    }
  }

  prepareChartData = (ledgerAmounts) => {
    if (!Array.isArray(ledgerAmounts)) return;

    // Map each ledger to {name, value} for PieChart
    const chartData = ledgerAmounts.map(entry => ({
      name: entry.le_ledgername,
      value: Math.abs(parseFloat(entry.total_balance || 0))
    })).filter(entry => entry.value !== 0); // remove zero balances

    this.setState({ chartData });
  };

  render() {
    const { chartData } = this.state;
    const totalOverallAmount = chartData.reduce((sum, entry) => sum + entry.value, 0);

    const COLORS = [
      '#0088FE', '#00C49F', '#FFBB28', '#FF8042', 
      '#A28DD0', '#FF69B4', '#FF4500', '#00CED1'
    ];

    return (
      <Paper style={componentStyles.chartContainer} className="dashboardpad">
        <h3>Breakdown by Ledger Account</h3>
       


	   <div  className="ledgerpichart" style={componentStyles.chartContentWrapper}>
          {chartData.length > 0 ? (
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  innerRadius={30} 
                  outerRadius={60}
                  paddingAngle={5}
                  dataKey="value"
                  nameKey="name"
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => `$${value.toFixed(2)}`} />
                <Legend
                  layout="vertical"
                  verticalAlign="middle"
                  align="right"
                  wrapperStyle={componentStyles.legendStyle}
                  formatter={(value, entry) => {
                    const amount = entry.payload.value;
                    const percentage = totalOverallAmount > 0
                      ? ((amount / totalOverallAmount) * 100).toFixed(1)
                      : 0;
                    return (
                      <span style={{ color: 'black', fontWeight: 'bold' }}>
                        {entry.payload.name}
                        <div style={{
                          borderBottom: '1px solid black',
                          width: '100%',
                          marginTop: '2px',
                          marginBottom: '2px'
                        }} />
                        <span>
                          ${amount.toFixed(2)} &nbsp;&nbsp;&nbsp;&nbsp;{percentage}%
                        </span>
                      </span>
                    );
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <p>No ledger amounts data available.</p>
          )}
        </div>
      </Paper>
    );
  }
}

export default class Vendordashboard extends Component {

  constructor(props) {
        super(props);
		
const currentDate = new Date();

var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();

    this.state = {
    redirect: false,
    pagename: '',
    erropen: false,
    errortype: 'error',
    errormessage: '',
    salesinvoiceOverdue: [],
    topCustomersPaid: [],
    topAROutstanding: [],
    vendorBillLedgerAmounts: [],
    todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,
fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
 fromdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',
    loading: false,
    chartLoading: false,  
    error: null, chartSeries: [],
      

    labels: [],
  
};

  }
  
 getParameterByName(name, url) {
        if (!url) url = window.location.href;
        url = url.toLowerCase();
        name = name.replace(/[\\[\\]]/g, "\\$&").toLowerCase();
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    componentDidMount() {
        document.title = "Isifol Account - Cash Flow Forecast";
        document.body.style.backgroundColor = '#FFFFFF';
   this.props.parentdasCallback(
            "Vendor Cash Flow Forecast"
        ); 
       	  if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
this.VendorGraphApi();	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}


    }
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=37')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
  this.VendorGraphApi();
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
    handleErrorclose = () => {
        this.setState({ erropen: false });
    };

    fetchAllDashboardData = async () => {
    this.setState({ erropen: false });

    const { fromdate1, todate1 } = this.state;

    try {
  const overdueResp = await axios.get(
    localStorage.getItem("ISIurl") +
    `ajaxreports.php?action=vendordue&fromdate=${fromdate1}&todate=${todate1}&cmp_id=${localStorage.getItem('ISIcmpid')}`
);
  
        // ← ADD THIS
        console.log('Overdue Vendor Bills API Response:', overdueResp.data);

        this.setState({
            salesinvoiceOverdue: Array.isArray(overdueResp.data) ? overdueResp.data : [],
        });
    } catch (error) {
        console.error("Error fetching overdue sales invoices:", error);
        this.setState({
            erropen: true,
            errortype: 'error',
            errormessage: 'Failed to load overdue invoices. Please try again.',
            salesinvoiceOverdue: [],
        });
    }

    try {
      const topCustomersResp = await axios.get(
    `${localStorage.getItem("ISIurl")}ajaxreports.php?action=vendortoppaidamount&fromdate=${fromdate1}&todate=${todate1}&cmp_id=${localStorage.getItem('ISIcmpid')}`
);

        // ← ADD THIS
        console.log('Top Vendors API Response:', topCustomersResp.data);

        this.setState({
            topCustomersPaid: Array.isArray(topCustomersResp.data) ? topCustomersResp.data : [],
        });
    } catch (error) {
        console.error("Error fetching top customers by paid amount:", error);
        this.setState({
            erropen: true,
            errortype: 'error',
            errormessage: 'Failed to load top customers. Please try again.',
            topCustomersPaid: [],
        });
    }

    try {
       const arOutstandingResp = await axios.get(
    `${localStorage.getItem("ISIurl")}ajaxreports.php?action=vendoroutstanding&fromdate=${fromdate1}&todate=${todate1}&cmp_id=${localStorage.getItem('ISIcmpid')}`
);

    
        console.log('Top A/R Outstanding API Response:', arOutstandingResp.data);

        this.setState({
            topAROutstanding: Array.isArray(arOutstandingResp.data) ? arOutstandingResp.data : [],
        });
    } catch (error) {
        console.error("Error fetching top A/R outstanding:", error);
        this.setState({
            erropen: true,
            errortype: 'error',
            errormessage: 'Failed to load A/R outstanding. Please try again.',
            topAROutstanding: [],
        });
    }

    try {
    const response = await axios.get(
  `${localStorage.getItem("ISIurl")}ajaxreports.php?action=getVendorBillLedgerAmounts&fromdate=${fromdate1}&todate=${todate1}&cmp_id=${localStorage.getItem('ISIcmpid')}&category=Expenditure`
);


       

        this.setState({
            vendorBillLedgerAmounts: Array.isArray(response.data) ? response.data : [],
            error: null
        });
    } catch (error) {
        console.error("Error fetching vendor bill ledger amounts:", error);
        this.setState({
            erropen: true,
            errortype: 'error',
            errormessage: 'Failed to load vendor bill ledger amounts. Please try again.',
            vendorBillLedgerAmounts: [],
            error: error.message
        });
    }
	
};

	
	
	
	

fetchVendorBillLedgerAmounts = async () => {
    this.setState({ loading: true, error: null });
  const { fromdate1, todate1 } = this.state;

    try {
   const response = await axios.get(
  `${localStorage.getItem("ISIurl")}ajaxreports.php?action=getVendorBillLedgerAmounts&fromdate=${fromdate1}&todate=${todate1}&cmp_id=${localStorage.getItem('ISIcmpid')}&category=Expenditure`
);

	   if (!response.data || !Array.isArray(response.data)) {
            throw new Error('Invalid response format received');
        }

        this.setState({
            vendorBillLedgerAmounts: response.data,
            error: null
        });
    } catch (error) {
        console.error("Error fetching vendor bill ledger amounts:", error);
        this.setState({
            erropen: true,
            errortype: 'error',
            errormessage: 'Failed to load vendor bill ledger amounts. Please try again.',
            vendorBillLedgerAmounts: [],
            error: error.message
        });
    }
};

	
	
fromdatehandler = (newValue) => {
    this.setState({
        fromdate: newValue,
        fromdate1: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
    });
};

todatehandler = (newValue) => {
    this.setState({
        todate: newValue,
        todate1: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
    });
};


VendorGraphApi()
{
	const { fromdate, todate } = this.state;
  if (!fromdate || !todate) return;

  let labels = [];
  let current = dayjs(fromdate);
  const end = dayjs(todate);
  while (current.isBefore(end) || current.isSame(end, 'day')) {
    labels.push(current.format('MMM DD'));
    current = current.add(1, 'day');
  }

  this.setState({ loading: true });

  axios
    .get(
      localStorage.getItem("ISIurl") +
        `ajaxreports.php?action=vendorgraphgetall&fromdate=${dayjs(fromdate).format(
          'YYYY-MM-DD'
        )}&todate=${dayjs(todate).format('YYYY-MM-DD')}&cmp_id=${localStorage.getItem('ISIcmpid')}`
    )
    .then((response) => {
      const salesReports = response.data;

      const dataMap = {};
      salesReports.forEach((item) => {
        dataMap[item.transaction_date] = {
          vendorBills: parseFloat(item.vendorbill_amount || 0),
          vendorCreditNotes: parseFloat(item.vendorcredit_note_amount || 0),
          netExpenses: parseFloat(item.net_amount || 0),
        };
      });

      const vendorBills = labels.map((d) => (dataMap[d] ? dataMap[d].vendorBills : 0));
      const vendorCreditNotes = labels.map((d) => (dataMap[d] ? dataMap[d].vendorCreditNotes : 0));
      const netExpenses = labels.map((d) => (dataMap[d] ? dataMap[d].netExpenses : 0));

      const updatedChartSeries = [
        { data: vendorBills, label: 'Vendor Bills', borderColor: '#FF0000' },
        { data: vendorCreditNotes, label: 'Vendor Credit Notes', borderColor: '#00FFFF' },
        { data: netExpenses, label: 'Net Expenses', borderColor: '#800080' },
      ];

      this.setState({ labels, chartSeries: updatedChartSeries, loading: false });
    })
    .catch((error) => {
      console.error(error);
      this.setState({ labels: [], chartSeries: [], loading: false });
    });
	 this.fetchAllDashboardData();
	 
}
handleClickSearch = () => {
  this.VendorGraphApi();
	
};

  render() {
   const { fromdate, todate, labels, chartSeries, loading, error } = this.state;


    return (
   <React.Fragment>
                <div className="tabbox">
                    <p>
                        <Collapse in={this.state.erropen}>
                            <Alert
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={this.handleErrorclose}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                                severity={this.state.errortype}
                            >
                                {this.state.errormessage}
                            </Alert>
                        </Collapse>
                    </p>
                
                <div className="searchbox">
                    <ul>
                        <li>
                            <p>From Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        value={dayjs(this.state.fromdate)}
                                        className="txtbox"
                                        onChange={this.fromdatehandler}
                                         format="MM/DD/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>
                        <li>
                            <p>To Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        value={dayjs(this.state.todate)}
                                        className="txtbox"
                                        onChange={this.todatehandler}
                                        format="MM/DD/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>
                        <li>
                            <p>&nbsp;</p>
                            <p className="searchbutton">
                                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                                    Calculate
                                </Button>
                            </p>
                        </li>
                    </ul>
                </div>
                <div className="clear"></div>
                {loading ? (
                    <Stack justifyContent="center" alignItems="center" sx={{ height: 300 }}>
                        <CircularProgress />
                        <p>Loading sales data...</p>
                    </Stack>
                ) : error ? (
                    <Alert severity="error">{error}</Alert>
                ) : ( <React.Fragment>
                       
  <LineChart
  height={400}
  xAxis={[
    {
      id: 'xAxis',
      scaleType: 'band',
      data: labels,
      valueFormatter: (date) => date,
    },
  ]}
  yAxis={[{ id: 'yAxis', scaleType: 'linear' }]}
  series={chartSeries.map((s) => ({
    ...s,
    xAxisKey: 'xAxis',
    yAxisKey: 'yAxis',
    showMark: true,   // <-- Show dots
    area: false,
    curve: 'linear',  // <-- Sharp lines
  }))}
  margin={{ left: 50, right: 50, top: 20, bottom: 50 }}
  grid={{ vertical: true, horizontal: true }}
  skipAnimation
/>


         </React.Fragment>



                )}
                   <div style={componentStyles.tablesContainer}>
                    <DueOverdueCharts salesinvoiceOverdue={this.state.salesinvoiceOverdue} />
                    <OverdueSalesInvoiceTable salesinvoice={this.state.salesinvoiceOverdue} />
<VendorBillLedgerChart 
            ledgerAmounts={this.state.vendorBillLedgerAmounts}
            fromDate={this.state.fromdate1}
            toDate={this.state.todate1}
        />
                    <TopCustomersPaidTable topCustomersPaid={this.state.topCustomersPaid} />
                    <TopAROutstandingTable topAROutstanding={this.state.topAROutstanding} />
                </div>

                <div className="clear"></div></div>
            </React.Fragment>
	  
	  
	  
	  
    );
  }
}
